import React from 'react'
import Markdown from 'react-markdown'
import RichText from '../../lib/components/RichText'
import { ueberschriftenUnterH1 } from '../functions/ueberschriftenUnterH1'

// Anzeigentext als Markdown darstellen (#27).
//
// Bewusst OHNE rehype-raw: die Quelldateien der Live-Seite enthalten kein rohes
// HTML (alle 637 geprüft), und ohne diesen Zusatz kann eingeschleustes Markup
// nie zu einem Element werden — auch dann nicht, wenn später Redakteure eigene
// Texte schreiben. HTML-Entities wie &auml; löst CommonMark selbst auf.
const komponenten = {
    a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />
}

// Die Zwischentitel stehen unter der h1 der Anzeige (#236).
const remarkPlugins = [() => ueberschriftenUnterH1]

const JobContent = ({ markdown }) => {
    if (!markdown || !markdown.trim()) return null

    return (
        <RichText className="job-detail-content">
            <Markdown components={komponenten} remarkPlugins={remarkPlugins}>{markdown}</Markdown>
        </RichText>
    )
}

export default JobContent
